import { ICarrierContact } from 'types/carrier'
import { generateApiActionTypes } from 'utils/actions/generateActionTypes'
import { ENDPOINTS } from 'utils/api/callApi'
import { decamelizeKeysWithNumbers } from 'utils/api/decamelizeKeysWithNumbers'
import { keymirror } from 'utils/keymirror'

export const CONTACT_INFO_DIALOG_ACTION_TYPES = keymirror({
  OPEN_CONTACT_INFO_DIALOG: undefined,
  CLOSE_CONTACT_INFO_DIALOG: undefined,
})

export const EDIT_CONTACT_INFO_ACTION_TYPE = generateApiActionTypes('EDIT_CONTACT_INFO')

export const CONTACT_INFO_ACTION_TYPE = generateApiActionTypes('CONTACT_INFO')

export const getContactInfo = (id: string) => {
  const requestData = {
    endpoint: ENDPOINTS.carriers,
    id,
    group: 'contact_information',
  }
  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(CONTACT_INFO_ACTION_TYPE),
    },
  }
}

export const openContactInformationDialog = () => ({
  type: CONTACT_INFO_DIALOG_ACTION_TYPES.OPEN_CONTACT_INFO_DIALOG,
})

export const closeContactInformationDialog = () => ({
  type: CONTACT_INFO_DIALOG_ACTION_TYPES.CLOSE_CONTACT_INFO_DIALOG,
})

export const editContactInfo = (id: string, payload: ICarrierContact) => {
  const requestData = {
    endpoint: ENDPOINTS.carriers,
    id,
    method: 'PUT',
    group: 'contact_information',
    body: decamelizeKeysWithNumbers(payload),
  }
  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(EDIT_CONTACT_INFO_ACTION_TYPE),
    },
  }
}
